import { Injectable } from '@angular/core';
import Analytics from 'analytics';
import googleTagManager from '@analytics/google-tag-manager';
import { UtilService } from './util.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class GtmTagService {
  private analytics: any;

  constructor(private util: UtilService) {
    if (environment.gtm.send) {
      this.analytics = Analytics({
        app: environment.gtm.app,
        plugins: [
          googleTagManager({
            containerId: environment.gtm.tag
          })
        ]
      });
    } else {
      console.log('GTM desabilitado');
    }
  }

  pushTag(tag: any) {
    try {
      if (!environment?.production) {
        console.log(tag);
      }
      this.analytics?.track(tag.event, tag);
    } catch (e) {
      console.log(e);
    }
  }

  formatarParaGtmTagEvent(tag: string) {
    let texto = 'faq-' + tag;
    texto = this.util.removerAcentos(texto);
    texto = texto.trim().toLowerCase().replace('?', '').replace(/ /g, '-');
    return texto;
  }
}
